import { Link } from 'redux-little-router';
import styled, { css } from 'styled-components';
import { tangerineGradient, tangerineGradientRevert } from '../../styles';

export const LinkS = styled(Link)`
  padding: 7px 15px;
  border-radius: 3px;
  font-size: 13px;
  font-weight: 500;
  border: 0;
  cursor: pointer;
  text-decoration: none;
  background: ${({ theme }) => theme.colors.lightTangerine};
  color: ${({ theme }) => theme.colors.tangerine};

  &:focus,
  &:hover {
    color: ${({ theme }) => theme.colors.tangerine};
  }
`;

export const ContactMessagesButton = styled.button`
  padding: 6px 14px;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.fontTangerine};
  font-size: 13px;
  line-height: 23px;
  border: none;
  outline: none;
  cursor: pointer;

  display: flex;
  align-items: center;

  svg {
    margin-left: 10px;
    cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'pointer'};
  }

  ${({ disabled }) =>
    disabled &&
    css`
      cursor: not-allowed;
      background-color: ${({ theme }) => theme.colors.backgroundDarkSilver};
    `}
`;

export const ButtonS = styled.button`
  padding: 7px 15px;
  border-radius: 3px;
  font-size: 13px;
  font-weight: 500;
  border: 0;
  cursor: pointer;
  ${tangerineGradient};
  color: ${({ theme }) => theme.colors.white};
  border: none;

  &:hover,
  &:focus {
    ${tangerineGradientRevert};
    color: ${({ theme }) => theme.colors.white};
  }
`;

export const AssignButton = styled.button`
  position: absolute;
  padding-top: 3px;
  z-index: 1;
  border: 0;
  right: 0;
  outline: none;
  cursor: pointer;
  background: none;
  color: ${({ theme }) => theme.colors.backgroundGold};

  &:hover {
    color: ${({ theme }) => theme.colors.fontSilver};
  }

  &:disabled {
    opacity: .6;
    cursor: not-allowed;
    pointer-events: none;
    color: ${({ theme }) => theme.colors.fontSilver};
  }
`;

export const AddButton = styled.button`
  padding: 11px 16px;
  border: none;
  border-radius: 5px;
  font-size: 15px;
  line-height: 18px;
  cursor: pointer;
  background: linear-gradient(270deg, #FD700F 0%, #FF9700 100%);
  color: ${({ theme }) => theme.colors.white};

  &:hover,
  &:focus {
    background-image: linear-gradient(to right, #FD700F 0%, #FF9700 100%);
  }
`;



// WEBPACK FOOTER //
// ./src/components/ui-helpers/buttons.js